import { map, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { DbFile } from '../models/file.model';
import { ApolloService } from './apollo.service';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  private return = `
    {
      id,
      name,
      src
    }
  `;

  constructor(private apolloService: ApolloService) {}

  getFiles(): Observable<DbFile[]> {
    return this.apolloService.query(`{files${this.return}}`, 'files');
  }

  getFile(fileId: string): Observable<DbFile> {
    return this.apolloService.query(
      `{file(id: "${fileId}")${this.return}}`,
      'file'
    );
  }

  createFile(file: DbFile): Observable<DbFile> {
    return this.apolloService.mutate(
      `CreateFile($file: CreateFileInput!) {
            createFile(createFileInput: $file)${this.return}
          }`,
      'createFile',
      { file }
    );
  }

  deleteFile(fileId: string): Observable<boolean> {
    return this.apolloService
      .mutate<number>(
        `RemoveFile($fileId: UUID!) {
                    removeFile(id: $fileId)
                }`,
        'removeFile',
        { fileId }
      )
      .pipe(map((x) => x > 0));
  }
}
